import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.scss";
import CompanyPage from "./pages/Company/CompanyPage";
import AppsPage from "./pages/Apps/AppsPage";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/*" element={<CompanyPage />} />
        <Route path="/apps" element={<AppsPage />} />
      </Routes>
    </Router>
  );
}

export default App;
